import { createI18nText } from '@hilma/netina2all';

const associationManagementText = createI18nText({
    he: {
        title: 'פרטי העמותה',
        saveOptions: {
            dontSend: 'שמור מבלי לשלוח',
            send: 'שמור ושלח'
        },

        image: {
            drag: <>גרור תמונה לכאן<br />או</>,
            add: 'הוסף תמונה',
        },

        name: 'שם העמותה',
        email: 'מייל',
        phone: 'טלפון',
        additionalPhone: 'טלפון נוסף',
        contactPerson: 'איש קשר מטעם העמותה',
        contactPersonShort: 'איש קשר',
        director: 'אחראי העמותה',
        signedContract: 'אישור חוזה חתום',
        downloadSignedContract: 'הורדת חוזה',
        acceptedProcedure: 'ניהול תקין',
        section46: 'סעיף 46',
        section46Exp: 'תוקף לסעיף 46',
        selectDate: 'בחר תאריך',

        bankInfo: {
            title: 'פרטי בנק',
            accountHolder: 'על שם מי החשבון',
            accountHolderRule: 'שם בעל החשבון',
            bank: 'בנק',
            branch: 'סניף',
            bankAccountNumber: 'מספר חשבון',
        },

        drivers: 'נהגים',
        addDriver: 'הוסף נהג/ת',
        dInfo: {
            dName: 'שם מלא',
            phone: 'טלפון',
            city: 'עיר',
            address: 'כתובת',
            carModel: 'סוג רכב',
            stateCarModel: 'ציין סוג רכב',
            hourRange: 'טווח שעות',
            notes: 'הערות'
        },
        carModels: {
            small: 'רכב קטן',
            family: 'רכב משפחתי',
            stationCar: 'רכב סטיישן',
            sevenSeats: 'רכב 7 מקומות',
            other: 'אחר (נא ציין את סוג הרכב למטה)',
        },
        close: 'סגירה',
        save: 'שמירה',
        add: 'הוסף',
        send: 'שלח',

        managerDetails: 'פרטי אחראי',
        managerFullName: 'שם מלא - אחראי',
        managerEmail: 'מייל',
        managerPhone: 'טלפוןן נייד',

        additionalDetails: 'פרטים נוספים',
        numVol: 'כמות מתנדבים',
        url: 'אתר העמותה (או דף הפייסבוק)',
        goalKits: 'יעד מוצרים',
        goalKitsLong: 'יעד מוצרים (למעוניינים)',

        uploadFile: 'העלה קובץ',

        pending: {
            titleThe: 'פרטי ה',
            entityName: 'עמותה',

            the: 'פרטי ה',
            sent: 'נשלחו לאישור,',

            notify: 'נעדכן אותך כאשר תקבל אישור'

        },

        associationName: 'שם העמותה',
        organizationManager: 'אחראי העמותה',
        contact: 'שם איש קשר מטעם העמותה',
        id: 'מספר עמותה',
        section46Expiry: 'סעיף 46',
        validUntil: 'בתוקף עד: ',
        bankAccountHolder: 'על שם מי החשבון?',
        bankName: 'בנק',
        bankBranchNumber: 'סניף',
        bankAccountNumber: 'מספר חשבון',

        volunteerNumber: 'כמות מתנדבים',
        sumDonated: 'סכום משוער שנתרם עד כה',
        website: 'קישור לאתר העמותה',
        purchaseLink: 'קישור ייעודי לרכישה',
        linkTooltip: 'קישור זה מאפשר רכישה אוטומטית מעמותה זו',
        copyLink: 'העתק קישור',
        contactUs: 'המידע לא עדכני? הפרטים לא נכונים?',
        web: 'האתר',

        banner: {
            sold: 'מוצרים נמכרו ב',
            this: 'זו',
            donatedSoFar: 'נתרמו עד כה: ',
            shekel: 'ש"ח',
            outOf: 'מתוך יעד של',
            kits: 'מוצרים',
            donatedOfGoal: 'נמכרו מהיעד',
            nonFinalSum: 'הסכום אינו מדוייק ויתכנו שינויים'
        },
        receipt: 'קבלה בסוף השנה'
    },
    en: {
        title: 'Association Details',
        saveOptions: {
            dontSend: 'Save without sending',
            send: 'Save and send'
        },

        image: {
            drag: <>Drag and drop here<br />or</>,
            add: 'Select image'
        },

        name: 'Association Name',
        email: 'Email',
        phone: 'Phone',
        additionalPhone: 'Additional Phone',
        contactPerson: 'Contact on behalf of the association',
        contactPersonShort: 'Contact',
        director: 'Director of the association',
        signedContract: 'Confirmed signed contract',
        downloadSignedContract: 'Download contract',
        acceptedProcedure: 'Accepted Procedure',
        section46: 'Section 46',
        section46Exp: "Section 46's expiration date",
        selectDate: 'Select Date',

        bankInfo: {
            title: 'Bank Information',
            accountHolder: 'Account holder',
            accountHolderRule: 'Account holder',
            bank: 'Bank',
            branch: 'Branch',
            bankAccountNumber: 'Account number',
        },

        drivers: 'Drivers',
        addDriver: 'Add driver',
        dInfo: {
            dName: 'fullName',
            phone: 'Phone',
            city: 'City',
            address: 'Address',
            carModel: 'Car Model',
            stateCarModel: 'State Car Model',
            hourRange: 'Hour range',
            notes: 'Notes'
        },
        carModels: {
            small: 'Small Car',
            family: 'Family Car',
            stationCar: 'Station Car',
            sevenSeats: '7 Seats Car',
            other: 'Other (please state the model below)',
        },
        close: 'Close',
        save: 'Save',
        add: 'Add',
        send: 'Send',

        managerDetails: 'Manager Details',
        managerFullName: 'Manager Name',
        managerEmail: 'Email',
        managerPhone: 'Phone',

        additionalDetails: 'Additional Details',
        numVol: 'Number of volunteers',
        url: "Website (or Facebook)",
        goalKits: 'Goal number of products',
        goalKitsLong: 'Goal number of products (for those interested)',

        uploadFile: 'Upload file',

        pending: {
            titleThe: 'Details',
            entityName: 'Association',

            the: 'The',
            sent: 'details have been sent,',

            notify: "We'll notify you when your association is approved"
        },

        associationName: 'Association name',
        organizationManager: 'Director',
        contact: 'Contact on behalf of the association',
        id: 'Association number',
        section46Expiry: 'סעיף 46',
        validUntil: 'Valid until: ',

        bankAccountHolder: 'Bank account holder',
        bankName: 'Bank name',
        bankBranchNumber: 'Bank branch',
        bankAccountNumber: 'Bank Number',
        volunteerNumber: 'Number of volunteers',
        sumDonated: 'Estimated sum donated so far',
        website: 'Link to association',
        purchaseLink: 'Direct link to purchase',
        linkTooltip: 'This link enables purchasing automatically from this station.',
        copyLink: 'Copy link',
        contactUs: 'Incorrect details?',
        web: 'website',

        banner: {
            sold: 'Products were sold in this',
            this: '',
            donatedSoFar: 'Donated so far: ',
            shekel: 'Shekel',
            outOf: 'Out of',
            kits: 'products',
            donatedOfGoal: 'Recruited from the target',
            nonFinalSum: 'The sum is not final and is due to change'
        },
        receipt: 'Donation receipt'
    }
})

export default associationManagementText